import React from 'react'
import { withIcon } from '../../withIcon'

function FastForwardIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M2.82764 17.8452C2.71392 17.8452 2.60189 17.8153 2.50342 17.7593C2.40501 17.7032 2.3229 17.6229 2.26611 17.5259C2.20925 17.4287 2.18003 17.3178 2.18018 17.2056L2.18017 6.79444C2.18003 6.68225 2.20925 6.57132 2.26611 6.47412C2.3229 6.37708 2.40501 6.29682 2.50342 6.24072C2.60189 6.18469 2.71392 6.15483 2.82764 6.15479C2.94151 6.15483 3.05426 6.18454 3.15283 6.24072L11.3706 10.9155L11.3706 6.79443C11.3705 6.68225 11.4007 6.57132 11.4575 6.47412C11.5144 6.37709 11.5963 6.29676 11.6948 6.24072C11.7934 6.18467 11.9052 6.15475 12.019 6.15479C12.1328 6.15487 12.2448 6.18459 12.3433 6.24072L21.4956 11.4468C21.5941 11.5028 21.676 11.5841 21.7329 11.6812C21.7896 11.778 21.8197 11.8877 21.8198 11.9995C21.8198 12.1115 21.7897 12.2218 21.7329 12.3188C21.676 12.4159 21.5941 12.4972 21.4956 12.5532L12.3433 17.7593C12.2448 17.8154 12.1328 17.8451 12.019 17.8452C11.9052 17.8453 11.7934 17.8153 11.6948 17.7593C11.5964 17.7032 11.5144 17.6229 11.4575 17.5259C11.4007 17.4287 11.3705 17.3178 11.3706 17.2056L11.3706 13.0855L3.15283 17.7593C3.05426 17.8155 2.94151 17.8452 2.82764 17.8452Z" fill={color}/>
    </svg>
  )
}

export default withIcon(FastForwardIcon)
